export const defaultCollection = 'all'
export const decimalToIntMultiplier = 100_000_000
export const hnftDiscord = 'https://discord.gg/hnft'
export const hnftTwitter = 'https://twitter.com/NFT_Relics'
